import {Platform} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import analytics from '@react-native-firebase/analytics';
import DeviceInfo from 'react-native-device-info';
import {version as appVersion} from '../../../../../../package.json';
import {useAuth} from '../../../../../context/auth';
import {PPDebitoDTO} from '../../../../../dtos/ProntoPagueiDTO';

type Props = {
  selectedDebits: PPDebitoDTO[];
  totalSelectedValue: number;
  consultaId: string;
  uuid: string;
  placa: string;
  pixDebitoVeicular: boolean;
};

export function useVerParcelas({
  selectedDebits,
  totalSelectedValue,
  consultaId,
  uuid,
  placa,
  pixDebitoVeicular,
}: Props) {
  const navigation = useNavigation();
  const {user} = useAuth();

  function handleVerParcelas() {
    analytics().logEvent('pp_selecionou_debitos', {
      user_id: user?.user_id,
      consulta_id: consultaId,
      debitos_count: selectedDebits.length,
      valor_total: totalSelectedValue,
      app_version: appVersion,
      device_model: DeviceInfo.getModel(),
      os: Platform.OS,
      os_version: DeviceInfo.getSystemVersion(),
    });

    navigation.navigate('PP_Checkout', {
      value: totalSelectedValue,
      uids: selectedDebits.map(item => item.uid),
      consultaId,
      uuid,
      placa,
      enablePix: pixDebitoVeicular,
    });
  }

  return {handleVerParcelas};
}   